// extracted by mini-css-extract-plugin
export var whatMain = "WhatWeDo-module--whatMain--SubD9";
export var spacing = "WhatWeDo-module--spacing--BQ5ut";